module.exports = __webpack_public_path__ + "static/img/bg-login.11862183.png";